import { RequestState, RowNew } from '../../../../components/Table/types';
import { flattenMints } from '../../../../utils/flattenMints';
import { useCustomSort } from '../../../../utils/sortByCreatedAt';
import { useGetMintQueries } from './useGetMintQueries';

export const useGetMintRows = () => {
  const mintQueries = useGetMintQueries();

  const queryDataMap = [
    { query: mintQueries.mintRequest, state: RequestState.Requested, isThreeStep: false },
    { query: mintQueries.mintRequest3Step, state: RequestState.Offered, isThreeStep: true },
    { query: mintQueries.executedMint, state: RequestState.Executed, isThreeStep: false },
    { query: mintQueries.executedMints3Step, state: RequestState.Executed, isThreeStep: true },
    { query: mintQueries.failedMints3Step, state: RequestState.Failed, isThreeStep: true },
    { query: mintQueries.rejectedMints, state: RequestState.Rejected, isThreeStep: false },
    { query: mintQueries.rejectedMints3Step, state: RequestState.Rejected, isThreeStep: true },
  ];

  const isLoading = queryDataMap.some(({ query }) => query.isLoading);

  const rows = queryDataMap.reduce((acc: RowNew[], { query, state, isThreeStep }) => {
    const dataArray = query.data || [];

    const newRows = flattenMints(dataArray, state, isThreeStep);

    return acc.concat(newRows);
  }, []);
  const sortedByCreateTime = useCustomSort(rows);
  return {
    isLoading,
    rows: sortedByCreateTime,
  };
};
